import { render, staticRenderFns } from "./TextPublicDisplayItem.vue?vue&type=template&id=3686f5ee"
import script from "./TextPublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./TextPublicDisplayItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3686f5ee')) {
      api.createRecord('3686f5ee', component.options)
    } else {
      api.reload('3686f5ee', component.options)
    }
    module.hot.accept("./TextPublicDisplayItem.vue?vue&type=template&id=3686f5ee", function () {
      api.rerender('3686f5ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/TextPublicDisplayItem.vue"
export default component.exports